import styled from '@emotion/styled';
import { Variables } from '../base';

/** The row the tiles sit in. Wraps rather than scrolls — five tiles is a lot on a narrow window. */
export const StatCardRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;
`;

export const StatCard = styled.div`
    flex: 1 1 180px;
    min-width: 180px;
    background-color: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: ${Variables.Rounded.medium};
    padding: 16px 20px;
`;

export const StatLabel = styled.div`
    color: ${Variables.Swatches.Gray6};
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 8px;
`;

export const StatValue = styled.div<{ urgent: boolean }>`
    color: ${(props): string => (props.urgent ? Variables.Colors.r50 : Variables.Swatches.Gray11)};
    font-size: 26px;
    font-weight: 600;
    line-height: 1.15;
`;

export const StatSub = styled.div`
    color: ${Variables.Swatches.Gray6};
    font-size: 12px;
    margin-top: 6px;
`;

/**
 * Shown in place of a value the page cannot answer yet.
 *
 * A dash, not a zero. Zero is a measurement — "no denials are near their filing deadline" — and
 * rendering it for "we have no way to know" states something false about the practice's money
 * (NS-3, NS-4).
 */
export const StatUnavailable = styled.div`
    color: ${Variables.Swatches.Gray5};
    font-size: 26px;
    font-weight: 600;
    line-height: 1.15;
`;
